import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {FireInTheHole2} from "../FireInTheHole2";
import {gsap} from "gsap";
import {FITH2Helper} from "../utils/FITH2Helper";
import {ScatterCounter} from "../view/ScatterCounter";
import {FITH2GameMode} from "../server/FITH2GameMode";

export class FITH2RoundEndPresentation implements SimplePresentation {
    constructor() {
    }

    shouldRun(): boolean {
        return FireInTheHole2.model.data.nextMode != FITH2GameMode.NORMAL_AVALANCHE;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(()=>{
            if(!FireInTheHole2.model.freespinTriggeredThisSpin){
                ScatterCounter.reset();
            }
            FireInTheHole2.reelAnticipation.reset();
        });

        tl.add(() => controller.setSkipCallback());
        tl.to(this, {duration: 0.01});
        tl.add(()=>{controller.finish()});
    }
}